import { render, staticRenderFns } from "./MainContact.vue?vue&type=template&id=1a81be16"
import script from "./MainContact.vue?vue&type=script&lang=js"
export * from "./MainContact.vue?vue&type=script&lang=js"
import style0 from "./MainContact.vue?vue&type=style&index=0&id=1a81be16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports